import {
  AfterViewInit,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { GT2PageAbstract } from '../../../content/abstract/GT2PageAbstract';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NGXLogger } from 'ngx-logger';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { ProductsService } from '../../../api/products.service';
import { Settings } from '../../../settings/settings';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { ItemUrlFinder } from '../../../utils/item-url-finder';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-create-combo-dynamic',
  templateUrl: './create-combo-dynamic.component.html',
  styleUrls: ['./create-combo-dynamic.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule,
    CommonModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class CreateComboDynamicComponent
  extends GT2PageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  form: UntypedFormGroup;
  product: any;
  override loading: boolean = false;
  autoRedirect: boolean = false;

  constructor(
    public override dialogRef: MatDialogRef<CreateComboDynamicComponent>,
    private translationLoader: FuseTranslationLoaderService,
    private translate: TranslateService,
    private productsService: ProductsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
    public dialog: MatDialog,
    public router: Router,
    private toastr: ToastrService,
    private logger: NGXLogger,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    this.form = this.formBuilder.group({
      name: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
    });

    this.product = {
      name: null,
      invoice_category: 'FOOD', // default value
    };

    if (data && data.autoRedirect !== null) {
      this.autoRedirect = data.autoRedirect;
    }
  }

  ngOnInit() {}

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public onCreateComboDynamic(): void {
    this.loading = true;
    this.productsService.createComboDynamic(this.product).subscribe({
      next: (response) => {
        this.toastr.success(
          '',
          this.translate.instant('GENERIC.API_CALL_SUCCESS.CREATE_PRODUCT'),
        );
        this.dialogRef.close(response.data);
        this.loading = false;
        if (this.autoRedirect) {
          const prefix = localStorage.getItem('PREFIX') || '';
          this.router.navigateByUrl(
            prefix + ItemUrlFinder.getItemURL(response.data),
          );
        }
      },
      error: (error) => {
        this.loading = false;
        this.logger.error(
          'CreateComboDynamicComponent.onCreateComboDynamic() -> ERROR: ' +
            JSON.stringify(error),
        );
        this.handleAPIError(error, this.dialog, null, null, this.router);
      },
    });
  }
}
